// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-store-list__title{margin-bottom:8px;font-size:16px;line-height:24px;color:var(--z2kad5)}", ""]);
// Exports
module.exports = exports;
